module.exports = __webpack_public_path__ + "img/yanzhong_icon.6e7802d9.gif";